import { useEffect, useState, useCallback } from "react";
import getCookie from "../components/LanguageProvider/utils/cookies";
import { removeFbclidCookie } from "../utils/UTM";
import { parseConsentCookie } from "../utils/cookieConsent";
import safely from "../utils/safeCookie";
export default function useCookieConsent() {
    const [consent, setConsent] = useState(null);
    const removeFunctionalCookies = useCallback(() => {
        ["movement", "language"].forEach((cookieName) => {
            document.cookie = `${cookieName}=; max-age=0; path=/`;
        });
    }, []);
    const applyConsentToAll = useCallback(() => {
        setConsent({
            action: "yes",
            advertisement: "yes",
            analytics: "yes",
            consent: "yes",
            functional: "yes",
            necessary: "yes",
            other: "yes",
            performance: "yes",
        });
    }, []);
    const denyConsentToAll = useCallback(() => {
        setConsent({
            action: "no",
            advertisement: "no",
            analytics: "no",
            consent: "no",
            functional: "no",
            necessary: "no",
            other: "no",
            performance: "no",
        });
    }, []);
    const processConsent = useCallback(() => {
        var _a;
        const cookie = safely(() => getCookie("cookieyes-consent"), null);
        if (!cookie) {
            if ((_a = window.Chuffed) === null || _a === void 0 ? void 0 : _a.isUkOrEu) {
                safely(removeFbclidCookie, undefined);
                denyConsentToAll();
            }
            else {
                applyConsentToAll();
            }
            return;
        }
        const parsed = parseConsentCookie(cookie);
        if (parsed.functional === "no") {
            safely(removeFunctionalCookies, undefined);
        }
        if (parsed.analytics !== "yes") {
            safely(removeFbclidCookie, undefined);
        }
        setConsent(parsed);
    }, [applyConsentToAll, denyConsentToAll, removeFunctionalCookies, setConsent]);
    useEffect(() => {
        processConsent();
        // Listen for user updates
        const handleUpdate = () => {
            processConsent();
        };
        document.addEventListener("cookieyes_consent_update", handleUpdate);
        return () => document.removeEventListener("cookieyes_consent_update", handleUpdate);
    }, [processConsent]);
    const hasConsented = (category) => {
        if (!consent) {
            return false;
        }
        return consent[category] === "yes";
    };
    return { consent, hasConsented };
}
